import { SignupForm } from "@/components/auth/SignupForm";
import { Logo } from "@/components/icons";
import { Link, useSearchParams } from "react-router-dom";
import { useMemo } from "react";
import { ChevronLeft } from "lucide-react";

const safeRedirect = (value: string | null | undefined): string | undefined => {
  if (!value) {
    return undefined;
  }

  if (!value.startsWith("/")) {
    return undefined;
  }

  if (value.startsWith("//")) {
    return undefined;
  }

  return value;
};

export default function SignupPage() {
  const [searchParams] = useSearchParams();
  const redirectParam = useMemo(() => {
    const redirect = searchParams.get("redirect");
    return safeRedirect(redirect || undefined);
  }, [searchParams]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background p-6">
      <div className="w-full max-w-md space-y-8">
        <div className="flex flex-col items-center text-center">
          <Link to="/" className="mb-4">
            <Logo className="h-20 w-20 text-primary" />
          </Link>
          <h1 className="font-headline text-3xl font-bold">Create an Account</h1>
          <p className="text-muted-foreground">Join ezRecipeBox and start sharing your favorite recipes.</p>
        </div>
        <SignupForm redirectTo={redirectParam} />
        <p className="px-8 text-center text-sm text-muted-foreground">
          By clicking continue, you agree to our{" "}
          <Link
            to="/terms"
            className="underline underline-offset-4 hover:text-primary"
          >
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link
            to="/privacy"
            className="underline underline-offset-4 hover:text-primary"
          >
            Privacy Policy
          </Link>
          .
        </p>
        <p className="text-center text-sm">
          <Link
            to="/"
            className="inline-flex items-center gap-1 text-muted-foreground hover:text-primary transition-colors"
          >
            <ChevronLeft className="h-4 w-4" />
            Back to Home
          </Link>
        </p>
      </div>
    </div>
  );
}

